export default __webpack_public_path__ + "static/media/appOverview2.d7830fd6.png";